import { styled } from 'styled-components'
import HomePageVideo from 'pages/HomePage/Components/HomePageVideo/HomePageVideo'
import GlassButton from 'components/GlassButton/GlassButton'
import { posterAsTallAsVideoStyles } from '../heroSection.styles'
import {
  MULTI_PRODUCT_APP_MOCKUP_FRAME,
  MULTI_PRODUCT_APP_PHONE_IMAGE,
} from '../../multiProductHomePage.consts'

const {
  width: phoneImageWidth,
  height: phoneImageHeight,
  screenWindow,
  phoneBody,
} = MULTI_PRODUCT_APP_PHONE_IMAGE

const {
  width: mockupWidth,
  height: mockupHeight,
  phoneTop,
} = MULTI_PRODUCT_APP_MOCKUP_FRAME

// Where the phone itself starts and ends across the image; the rest is margin and shadow.
const PHONE_START = phoneBody.left / phoneImageWidth
const PHONE_END = phoneBody.right / phoneImageWidth

const BACKGROUND_BLUE = '#dff0fd'
const BACKGROUND_WARM = '#faf3ea'

export const Container = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'content mockup';
  align-items: center;
  gap: 20px;
  padding: 48px 0;
  background: linear-gradient(
    9.8deg,
    ${BACKGROUND_BLUE} 68%,
    ${BACKGROUND_WARM} 102%
  );
`

export const Mockup = styled.div`
  position: relative;
  grid-area: mockup;
  width: min(${mockupWidth}px, 100%);
  aspect-ratio: ${mockupWidth} / ${mockupHeight};
`

export const Phone = styled.div`
  position: absolute;
  top: calc(100% * ${phoneTop} / ${mockupHeight});
  inset-inline: 0;
`

// HomePageVideo positions its <video> absolutely, so the box needs the video's 9:16 ratio.
export const PhoneVideo = styled(HomePageVideo)`
  position: absolute;
  z-index: 0;
  top: calc(100% * ${screenWindow.top} / ${phoneImageHeight});
  left: calc(100% * ${screenWindow.left} / ${phoneImageWidth});
  width: calc(100% * ${screenWindow.width} / ${phoneImageWidth});
  aspect-ratio: 9 / 16;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.white};

  ${posterAsTallAsVideoStyles}
`

export const PhoneImage = styled.img`
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
`

export const Content = styled.div`
  grid-area: content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  /* Mirrors the phone's gap to the page edge, running into the empty space left of it. */
  --mockup-width: min(${mockupWidth}px, 100%);
  padding-inline: calc(100% - var(--mockup-width) * ${PHONE_END}) 38px;
  margin-inline-end: calc(var(--mockup-width) * ${-PHONE_START});
  text-align: start;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 481px;
`

export const Title = styled.h2`
  margin: 0;
  font-size: 40px;
  line-height: 1.2;
  font-weight: 600;
  text-wrap: balance;
  color: ${({ theme }) => theme.colors.black};
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 24px;
  line-height: 1.27;
  font-weight: 400;
  text-wrap: balance;
  color: ${({ theme }) => theme.colors.black};
`

export const DownloadButton = styled(GlassButton)`
  min-width: 122px;
`

export const AppStoreBadgeButton = styled.button`
  display: block;
  padding: 0;
  border: none;
  background: none;
  line-height: 0;
  cursor: pointer;
`
